var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.themeStyle!=='bgOff')?_c('progressive-background',{staticClass:"spaceBackground",attrs:{"src":"/assets/purpleSpace.jpg"}}):_vm._e(),_vm._v(" "),_c('canvas',{ref:"visualizerCanvas"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }